import React, { useState, useEffect, useRef } from 'react';
import '../../../../component/InputTable/InputTable.scss';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import { product_list } from '../../../../store/action/product';
import ErrorModal from '../../../../component/ErrorModal/ErrorModal';
import { getProductBatchList, getProductList } from '../../../../services/products';
import { toast } from 'react-toastify';
import { getDate } from '../../../../utils/dateUtils';

const NoteTable = ({
	initialRows,
	columns,
	className,
	onChange,
	value,
	disabled,
	newRowgenerate = '',
	returnInputvalue,
	errorCells,
	setErrorCells,
	tableError,
	setIsTableErrorShow,
}) => {
	const [batchOptions, setBatchOptions] = useState([]);
	const [productOptions, setProductOptions] = useState([]);
	const [productDetails, setProductDetails] = useState([]);
	const [selectedRowData, setSelectedRowData] = useState({});
	const [rows, setRows] = useState([]);
	const [showError, setShowError] = useState(false);
	const inputRefs = useRef([]);
	const [loading, setLoading] = useState(false);
	const date = new Date();
	const ThisYear = date.getFullYear().toString().slice(-2);
	const Thismonth = (date.getMonth() + 1).toString().padStart(2, '0');

	async function fetchProduct(param) {
		try {
			const productList = await getProductList(param);
			const productOptions = productList?.productWithStockCount?.map((ele) => ({
				key: ele?.product_id,
				value: ele?.product_name,
			}));
			setProductOptions(productOptions);
		} catch (error) {
			toast.error('Something went wrong! while fetching the product list.');
		}
	}

	useEffect(() => {
		let param = {
			page: 1,
			pageSize: 2000,
			filterBy: 'status',
			filterValue: '1',
		};
		fetchProduct(param);
	}, []);

	useEffect(() => {
		if (errorCells.length > 0) {
			setIsTableErrorShow(true);
		} else {
			setIsTableErrorShow(false);
		}
	}, [errorCells]);

	useEffect(() => {
		if (tableError && rows?.length > 0 && errorCells.length > 0) {
			const LastRowIndex = rows.length - 1;
			const LastRow = rows[LastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = LastRow[col.name];

					return (
						(value === null ||
							value === '' ||
							value === 'MM/YY' ||
							value === '0.00' ||
							value === '0' ||
							Number(value) === 0) &&
						['product_id', 'batch_no', 'mfg_date', 'exp_date', 'mrp', 'quantity', 'rate'].includes(
							col.name,
						)
					);
				})
				.map((col) => ({
					index: LastRowIndex,
					name: col.name,
				}));

			setErrorCells((prevErrorCells) => [
				...prevErrorCells.filter((error) => !(error.index === LastRowIndex)),
				...errors,
			]);
		}
	}, [tableError]);

	useEffect(() => {
		setRows([]);
		setLoading(true);
		if (value?.length > 0) {
			setRows(value);
			setLoading(false);
		} else {
			setLoading(true);
			setRows(initialRows);
			setLoading(false);
		}
	}, [value, initialRows]);

	const getProductBatchByProductId = (productID, index) => {
		let param = `filterBy=product_id&filterValue=${productID ? productID : ''}`;
		product_list(param).then((res) => {
			if (res?.success) {
				let filteredProduct = res?.data?.productWithStockCount?.[0];
				let batch = res?.data?.productWithStockCount?.[0]?.product_batch?.map((ele) => ({
					key: ele.batch_no,
					value: ele.batch_no,
				}));
				setBatchOptions(batch || []);
				setSelectedRowData((prevData) => ({
					...prevData,
					[index]: filteredProduct,
				}));
			} else {
			}
		});
	};

	const getproductbyInoutValue = (func, delay) => {
		let timeoutId;
		return function (...args) {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				func.apply(this, args);
			}, delay);
		};
	};

	const debouncedFetchProduct = getproductbyInoutValue((query) => {
		fetchProduct(query);
	}, 300);

	const getProductById = (productId) => {
		return productDetails?.find((product) => product.product_id === productId);
	};

	const addRow = () => {
		const emptyRow = columns.reduce((acc, col) => {
			acc[col.name] = '';
			return acc;
		}, {});
		const newRows = [...rows, emptyRow];
		setRows(newRows);

		if (newRows.length > 1) {
			const secondLastRowIndex = newRows.length - 2;
			const secondLastRow = newRows[secondLastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];

					return (
						(value === null ||
							value === '' ||
							value === 'MM/YY' ||
							value === '0.00' ||
							value === '0') &&
						['product_id', 'batch_no', 'mfg_date', 'exp_date', 'mrp', 'quantity', 'rate'].includes(
							col.name,
						)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));

			setErrorCells((prevErrorCells) => [
				...prevErrorCells.filter(
					(er) =>
						!(er.index === secondLastRowIndex) &&
						(er.customErrorMessage === null || er.customErrorMessage === undefined),
				),
				...errors,
			]);
		}

		if (onChange) {
			onChange(newRows);
		}
		setTimeout(() => {
			inputRefs.current[newRows.length - 1]?.[0]?.focus();
			let lastRowRef = inputRefs.current[newRows.length - 1]?.[0];
			lastRowRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}, 0);
	};

	const deleteRow = (index) => {
		if (rows.length > 1) {
			const newRows = [...rows];
			newRows.splice(index, 1);

			let newErrorCells = errorCells
				.filter((error) => error.index !== index)
				.map((error) => ({
					...error,
					index: error.index > index ? error.index - 1 : error.index,
				}));

			let productCounts = {};
			newRows.forEach((row, i) => {
				if (row.product_id) {
					productCounts[row.product_id] = (productCounts[row.product_id] || 0) + 1;
				}
			});

			newErrorCells = newErrorCells.filter(
				(error) =>
					error.name !== 'product_id' || productCounts[newRows[error.index]?.product_id] > 1,
			);

			setErrorCells(newErrorCells);
			setRows(newRows);

			if (onChange) {
				onChange(newRows);
			}

			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
			}, 0);
		} else {
			setRows(initialRows);
			if (onChange) {
				onChange(initialRows);
			}
			setTimeout(() => {
				inputRefs.current[0]?.[0]?.focus();
			}, 0);
		}
	};

	const handleProductInputChange = async (index, value) => {
		const newRows = [...rows];
		const selectedProduct = productOptions?.find((prod) => prod?.key === value);
		newRows[index].product_id = selectedProduct?.key || '';
		var data;
		if (!isNaN(value) && value !== '') {
			data = await getProductList({
				filterBy: 'product_id',
				filterValue: value,
			});
		} else {
			data = null;
		}
		if (data != null && data?.productWithStockCount?.length > 0) {
			setSelectedRowData((prevData) => ({
				...prevData,
				[index]: data?.productWithStockCount[0],
			}));
			const batch = data?.productWithStockCount[0]?.product_batch?.map((ele) => ({
				key: ele.batch_no,
				value: ele.batch_no,
			}));
			newRows[index].tax =
				Number(data?.productWithStockCount[0]?.tax1 || 0) +
				Number(data?.productWithStockCount[0]?.tax2 || 0);
			setBatchOptions(batch);
		} else {
			newRows[index].tax = 0;
			setBatchOptions([]);
		}

		let error = [...errorCells.filter((er) => er.name !== 'product_id')];
		const productCounts = {};
		newRows.forEach((row, i) => {
			if (!row.product_id) {
				error.push({ index: i, name: 'product_id' });
			}

			if (row.product_id) {
				productCounts[row.product_id] = (productCounts[row.product_id] || 0) + 1;
			}
		});

		newRows.forEach((row, i) => {
			if (row.product_id && productCounts[row.product_id] > 1) {
				error.push({
					index: i,
					name: 'product_id',
					customErrorMessage: { product_id: 'This product already exists in the Purchase order.' },
				});
			}
		});

		setErrorCells(error);
		newRows[index].product_id = value;
		newRows[index].batch_no = '';
		newRows[index].mfg_date = '';
		newRows[index].exp_date = '';
		newRows[index].mrp = '';
		newRows[index].rate = '';
		newRows[index].quantity = '';
		newRows[index].amount = '';
		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const handleDateChange = (index, event, field) => {
		let { value } = event.target;
		value = value.replace(/\D/g, '');

		if (value.length > 4) {
			value = value.slice(0, 4);
		}

		if (value.length >= 2) {
			let month = value.slice(0, 2);
			const year = value.slice(2);

			if (month > '12') {
				month = '12';
			}
			if (value.length === 2) {
				value = `${month}`;
			} else {
				value = `${month}/${year}`;
			}
		}
		if (field === 'exp_date') {
			let currentRow = rows[index];
			let currentRowmfg_date = currentRow?.mfg_date;
			if (value === '' || currentRowmfg_date?.split('/')?.[1] > value?.split('/')?.[1]) {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
			}
		}
		if (field === 'mfg_date') {
			if (
				value === '' ||
				value?.split('/')?.[1] > ThisYear ||
				(value?.split('/')?.[1] >= ThisYear && value?.split('/')?.[0] > Thismonth)
			) {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
			}
		}

		const newRows = [...rows];
		newRows[index][field] = value;
		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const handleBatchChange = async (index, value, indexName) => {
		let name = indexName;
		let newRows = [...rows];
		if (value) {
			if (
				batchOptions &&
				newRows[index].product_id !== '' &&
				newRows[index].product_id !== undefined
			) {
				const data = await getProductList({
					filterBy: 'product_id',
					filterValue: newRows[index].product_id,
				});
				let batchData = data?.productWithStockCount[0]?.product_batch?.filter(
					(row) => row.batch_no === value,
				);
				if (batchData) {
					newRows[index].rate = batchData[0]?.purchase_rate ?? '0.00';
					newRows[index].mfg_date = getDate(batchData[0]?.mfg_date, false, false, true) ?? '';
					newRows[index].exp_date = getDate(batchData[0]?.expiry_date, false, false, true) ?? '';
					newRows[index].mrp = batchData[0]?.mrp ?? '0.00';
				} else {
					newRows[index].rate = '';
					newRows[index].mfg_date = '';
					newRows[index].exp_date = '';
					newRows[index].mrp = '';
				}
			} else {
				newRows[index].rate = '';
				newRows[index].mfg_date = '';
				newRows[index].exp_date = '';
				newRows[index].mrp = '';
			}

			newRows[index][name] = value;
			let totalAmountWithTax =
				Number(newRows[index].rate ?? 0) * Number(newRows[index].quantity ?? 0) +
				(Number(newRows[index].rate ?? 0) *
					Number(newRows[index].quantity ?? 0) *
					Number(newRows[index].tax ?? 0)) /
				100;

			newRows[index].amount = totalAmountWithTax;
			setRows(newRows);
			if (onChange) {
				onChange(newRows);
			}
		} else {
			newRows[index].rate = '';
			newRows[index].mfg_date = '';
			newRows[index].exp_date = '';
			newRows[index].mrp = '';
			newRows[index][name] = value;
			let totalAmountWithTax =
				Number(newRows[index].rate ?? 0) * Number(newRows[index].quantity ?? 0) +
				(Number(newRows[index].rate ?? 0) *
					Number(newRows[index].quantity ?? 0) *
					Number(newRows[index].tax ?? 0)) /
				100;

			newRows[index].amount = totalAmountWithTax;
			setRows(newRows);
			if (onChange) {
				onChange(newRows);
			}
		}
		if (value) {
			let updatedErrorCell = errorCells.filter(
				(cell) => !(cell.index === index && cell.name === 'batch_no'),
			);
			setErrorCells(updatedErrorCell);
		} else {
			setErrorCells([...errorCells, { index, name: 'batch_no' }]);
		}
		checkErrorForUpdateBatchNumber(index);
	};

	const handleChangeDefault = (index, event, field) => {
		let { name, value } = event.target;
		let valueData = '';
		if (field === 'quantity') {
			valueData = value?.replace(/[^0-9]/g, '');
		} else {
			valueData = value?.replace(/[^0-9.]/g, '');
			const decimalCount = (valueData.match(/\./g) || []).length;
			if (decimalCount > 1) {
				valueData = +valueData?.slice(0, valueData.lastIndexOf('.'));
			}
		}
		if (field === 'mrp') {
			if (Number(valueData) === 0 || valueData === '' || valueData === '0') {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
			}
		}
		if (field === 'quantity') {
			if (Number(valueData) === 0 || valueData === '' || valueData === '0') {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
			}
		}
		if (field === 'tax') {
			if (valueData === '') {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
			}
		}

		if (field === 'rate') {
			if (Number(valueData) === 0 || valueData === '' || valueData === '0') {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
				setIsTableErrorShow(!tableError);
			}
		}
		if (field === 'batch_no') {
			if (valueData === '') {
				setErrorCells([...errorCells, { index, name: field }]);
			} else {
				setErrorCells(errorCells.filter((cell) => !(cell.index === index && cell.name === field)));
			}
		}
		const newRows = [...rows];
		newRows[index][name] = valueData;
		let totalAmountWithTax =
			Number(newRows[index].rate ?? 0) * Number(newRows[index].quantity ?? 0) +
			(Number(newRows[index].rate ?? 0) *
				Number(newRows[index].quantity ?? 0) *
				Number(newRows[index].tax ?? 0)) /
			100;

		newRows[index].amount = totalAmountWithTax;
		setRows(newRows);
		if (onChange) {
			onChange(newRows);
		}
	};

	const handleKeyDown = (index, event) => {
		let { name, value } = event.target;
		if (event.key === 'Enter') {
			const column = columns.find((col) => col.name === event.target.name);
			if ((column && column.label === newRowgenerate) || (column && column.label === 'Amount')) {
				addRow();
			}
		} else {
			if (name === 'exp_date' || name === 'mfg_date') {
				handleDateChange(index, event, name);
			} else if (name === 'product_id') {
				handleProductInputChange(index, value);
			} else {
				handleChangeDefault(index, event, name);
			}
		}
	};

	const handleRef = (rowIndex, cellIndex) => (el) => {
		if (!inputRefs.current[rowIndex]) {
			inputRefs.current[rowIndex] = [];
		}
		inputRefs.current[rowIndex][cellIndex] = el;
	};

	const getToolTipData = (name) => {
		switch (name) {
			case 'product_id':
				return 'Name can not be empty.';
			case 'batch_no':
				return 'Batch No can not be empty';
			case 'mfg_date':
				return `mfg_date number can not be empty`;
			case 'exp_date':
				return `exp_date date can not be empty`;
			case 'mrp':
				return `MRP can not be empty`;
			case 'quantity':
				return `Quantity can not be empty`;
			case 'amount':
				return `Net Amount can not be empty`;
			case 'rate':
				return `Final Amount can not be empty`;
			default:
				return '';
		}
	};

	useEffect(() => {
		if (rows.length > 0 && onChange) {
			onChange(rows);
		}
	}, [disabled]);

	const ErrorModalOpen = () => {
		setShowError(true);
	};
	const CloseErrorModal = () => {
		setShowError(false);
		setTimeout(() => {
			if (rows.length > 0) {
				inputRefs.current[rows.length - 1]?.[0]?.focus();
			}
		}, 0);
	};
	const numberOfProducts = rows.length;

	async function handleFetchBatchNumber(rowIndex, colName, productId) {
		try {
			setBatchOptions([]);
			if (productId !== undefined && productId !== '' && productId !== null) {
				const data = await getProductBatchList({ product_id: productId });
				const productBatches =
					data?.length > 0
						? data?.map((batch) => {
							return {
								key: batch?.batch_no,
								value: batch?.batch_no,
							};
						})
						: [];
				setBatchOptions(productBatches);
			}
		} catch (error) {
			setBatchOptions([]);
			toast.error('Something went wrong!');
		}
	}

	function checkErrorForUpdateBatchNumber(rowIndex) {
		const row = rows[rowIndex];

		const errors = columns
			.filter((col) => {
				const value = row[col.name];

				return (
					(value === null ||
						value === '' ||
						value === 'MM/YY' ||
						value === '0.00' ||
						value === '0' ||
						Number(value) === 0) &&
					['product_id', 'batch_no', 'mfg_date', 'exp_date', 'mrp', 'quantity', 'rate'].includes(
						col.name,
					)
				);
			})
			.map((col) => ({
				index: rowIndex,
				name: col.name,
			}));

		setErrorCells((prevErrorCells) => [
			...prevErrorCells.filter((error) => !(error.index === rowIndex)),
			...errors,
		]);
	}

	return (
		<>
			{errorCells && errorCells?.length > 0 && (
				<div className="d-flex justify-content-end  text-danger  mb-0">
					{' '}
					<span
						style={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={ErrorModalOpen}
					>
						Show all error
					</span>
				</div>
			)}
			<div className="text-center  custum_table">
				<div className=" custom-scroll">
					<table className="purchase-table">
						<thead>
							<tr>
								{columns.map((col) => (
									<th
										className={`${className}`}
										key={col.name}
									>
										<div
											style={{
												display: 'flex',
												justifyItems: 'start',
												alignItems: 'center',
											}}
										>
											<span>{col.label}</span>
											<span style={{ color: 'red' }}>
												{[
													'product_id',
													'batch_no',
													'mfg_date',
													'exp_date',
													'mrp',
													'quantity',
													'amount',
													'rate',
												].includes(col.name)
													? '*'
													: ''}
											</span>
											{[
												'product_id',
												'batch_no',
												'mfg_date',
												'exp_date',
												'mrp',
												'quantity',
												'amount',
												'rate',
											].includes(col.name) ? (
												<i className="toolTip_custum fa fa-info-circle">
													<span className="toolTip_custumtext">{getToolTipData(col.name)}</span>
												</i>
											) : (
												''
											)}
										</div>
									</th>
								))}
								<th>Actions</th>
							</tr>
						</thead>
						{loading ? (
							<div
								className="d-flex justify-content-center align-items-center"
								style={{
									marginTop: '5%',
									marginLeft: '40%',
									position: 'fixed ',
								}}
							>
								<span
									className="Page_loader"
									role="status"
									aria-hidden="true"
								></span>
							</div>
						) : (
							<tbody>
								{rows.map((row, rowIndex) => (
									<tr key={rowIndex}>
										{columns.map((col, cellIndex) => (
											<td
												key={col.name}
												className={
													errorCells.some(
														(cell) => cell.index === rowIndex && cell.name === col.name,
													)
														? 'error'
														: ''
												}
											>
												{col.name === 'batch_no' ? (
													<InputSelect
														placeholder="Select Batch No"
														value={
															batchOptions?.find((option) => option.key === row[col.name])?.value ||
															row[col.name]
														}
														onChange={(value) => handleBatchChange(rowIndex, value, col?.name)}
														onSelect={(option) =>
															handleBatchChange(rowIndex, option.value, col?.name)
														}
														options={batchOptions}
														returnInputValue={returnInputvalue}
														disabled={disabled}
														propInputRef={handleRef(rowIndex, cellIndex)}
														isLocalValidationError={
															errorCells.some(
																(cell) => cell.index === rowIndex && cell.name === col.name,
															)
																? true
																: false
														}
														onClickDropdownIcon={() => {
															if (row?.product_id !== undefined && row?.product_id !== null) {
																handleFetchBatchNumber(rowIndex, col?.name, row?.product_id);
															}
														}}
														onfucusCapture={(e) => {
															if (row?.product_id !== undefined && row?.productId !== null) {
																handleFetchBatchNumber(rowIndex, col?.name, row?.product_id);
															}
														}}
													/>
												) : col.type === 'product_name' ? (
													<InputSelect
														placeholder="Select Product"
														value={row[col.name]}
														onChange={(value) => handleProductInputChange(rowIndex, value)}
														onSelect={(option) => handleProductInputChange(rowIndex, option.key)}
														isLocalValidationError={
															errorCells.some(
																(cell) => cell.index === rowIndex && cell.name === col.name,
															)
																? true
																: false
														}
														options={productOptions}
														disabled={disabled}
														returnInputValue={false}
														propInputRef={handleRef(rowIndex, cellIndex)}
													/>
												) : col.type === 'date' ? (
													<input
														type="text"
														name={col.name}
														value={row[col.name]}
														style={{
															border: '1px solid rgba(85, 91, 103, 0.15)',
															borderRadius: '8px',
															height: '38px',
														}}
														onChange={(e) => handleDateChange(rowIndex, e, col.name)}
														onKeyDown={(e) => handleKeyDown(rowIndex, e)}
														placeholder="MM/YY"
														maxLength="5"
														disabled={true}
														className="table_input"
														ref={handleRef(rowIndex, cellIndex)}
													/>
												) : (
													<input
														className="table_input"
														type={col.type}
														name={col.name}
														value={row[col.name]}
														style={{
															border: '1px solid rgba(85, 91, 103, 0.15)',
															borderRadius: '8px',
															height: '38px',
														}}
														onChange={(e) => handleChangeDefault(rowIndex, e, col.name)}
														onKeyDown={(e) => handleKeyDown(rowIndex, e)}
														disabled={col.name === 'quantity' ? false : true}
														ref={handleRef(rowIndex, cellIndex)}
													/>
												)}
											</td>
										))}
										<td>
											<button
												className="delete mt-0 bg-transparent"
												onClick={() => deleteRow(rowIndex)}
												tabIndex="-1"
												disabled={disabled}
											>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
												>
													<path
														d="M3 6H5H21"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M10 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M14 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											</button>
										</td>
									</tr>
								))}
							</tbody>
						)}
					</table>
				</div>
				<span
					className="d-flex "
					style={{
						border: '1px solid #C3CBDC',
						height: '36px',
						backgroundColor: '#F6F6F9',
						display: 'flex',
						alignItems: 'center',
						paddingLeft: '10px',
						paddingRight: '60px',
						justifyContent: 'space-between',
						width: '100%',
						margin: 'auto',
					}}
				>
					<div>
						<span
							style={{
								color: 'var(--sub, #555B67)',
								fontWeight: '400',
								fontSize: '14px',
							}}
						>
							Total Items :
						</span>
						<span
							style={{
								color: 'var(--sub, #555B67)',
								fontWeight: '700',
								fontSize: '14px',
								marginLeft: '5px',
							}}
						>
							{numberOfProducts}
						</span>
					</div>
					{/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<p style={{ margin: '5px 35px' }}>₹220</p>
						<p style={{ margin: '5px 30px' }}>30%</p>
						<p style={{ margin: '5px 45px' }}>₹322</p>
						<p style={{ margin: '5px 25px' }}>₹240</p>
					</div> */}
				</span>

				{!disabled && (
					<span style={{ display: 'flex', justifyContent: 'right' }}>
						<button
							className="bg-transparent text-dark add-new-row-button mt-2"
							onClick={addRow}
						>
							Add New Row
							<i
								className="fa fa-plus"
								style={{
									marginLeft: '.5rem',
									strokeWidth: '.1rem',
									color: 'var(--brand-color)',
									WebkitTextStrokeColor: '#fff',
									WebkitTextStrokeWidth: '1px',
								}}
							/>
						</button>
					</span>
				)}
			</div>
			<div className="text-start">
				{showError && (
					<ErrorModal
						show={showError}
						isOpen={showError}
						onClose={CloseErrorModal}
						title="Error in Add Inventory Table"
						error={errorCells}
					/>
				)}
			</div>
		</>
	);
};

export default NoteTable;
